import React from 'react';
import { useSortBy } from 'react-instantsearch';
import { useTranslation } from 'react-i18next';
import {
  SearchBar,
} from '@uncinc/react-searchkit';

import { APP_OPTIONS } from '../../../config/constants';

const SearchBarCustom = () => {
  const { t } = useTranslation();
  const sortValueScore = APP_OPTIONS.parameters.searchkitIndexAllContent;
  const sortValueCreated = `${APP_OPTIONS.parameters.searchkitIndexAllContent}_created_desc`;

  const {
    currentRefinement,
    refine,
  } = useSortBy({
    items: [
      { label: t('components.search.sort.relevance'), value: APP_OPTIONS.parameters.searchkitIndexAllContent },
      { label: t('components.search.sort.date_asc'), value: `${APP_OPTIONS.parameters.searchkitIndexAllContent}_created_asc` },
      { label: t('components.search.sort.date_desc'), value: `${APP_OPTIONS.parameters.searchkitIndexAllContent}_created_desc` },
      { label: t('components.search.sort.page_title_asc'), value: `${APP_OPTIONS.parameters.searchkitIndexAllContent}_page_title_asc` },
      { label: t('components.search.sort.page_title_desc'), value: `${APP_OPTIONS.parameters.searchkitIndexAllContent}_page_title_desc` },
    ],
  });

  return (
    <SearchBar
      title={t('components.search.searchbar.label')}
      buttonText={t('components.search.searchbar.search_button')}
      placeholder={t('components.search.searchbar.placeholder')}
      onSubmit={(query) => {
        // If our query is empty make sure we sort by date.
        if (!query && currentRefinement !== sortValueCreated) {
          refine(sortValueCreated);
        }
        // If we have a query then make sure the score sorting is activated.
        if (query && currentRefinement !== sortValueScore) {
          refine(sortValueScore);
        }
      }}
    />
  );
};

export default SearchBarCustom;
